// extracted by mini-css-extract-plugin
module.exports = {"pageFooter":"footer-module--page-footer--1DGWf","footerLogo":"footer-module--footer-logo--2PLb1"};